import { request } from '@mairistem/tools';
import { ENV_LOCAL } from '@/constants';
import { getRegiesCheckLimit } from '@/routes/regie';
import type { RegieLimitCheckType } from '@/types';

const checkRegieLimit = (): Promise<RegieLimitCheckType> => {
  if (ENV_LOCAL) {
    return Promise.resolve({
      facturier: {
        canCreate: true,
        currentCount: 0,
        limit: null,
        message: '',
      },
      autonome: {
        canCreate: true,
        currentCount: 0,
        limit: null,
        message: '',
      },
    });
  }

  return request.get(getRegiesCheckLimit());
};

export default checkRegieLimit;
